<template>
  <div>
    <section class="text_center">
      <h3 id="purchased">すでにNetRideCashを購入した方</h3>
      <p class="text_left">
        下記より金額を指定して頂き、その下の「確認画面へ」を押して進んでください。<br>
        次のページで用紙に記載されているプリペイド番号（16文字の英数字）をご入力頂くとポイントが追加されます。
      </p>
      <h3>決済金額選択</h3>

      <ValidationObserver ref="form">
        <form
          action=""
          method="post"
          class="form"
        >
          <div class="form_group">
            <ValidationProvider name="決済金額" rules="required" v-slot="{ errors }">
              <div class="select">
                <select
                  name="priceId"
                  :class="{
                    select_placeholder: true,
                    selected: form.priceId !== ''
                  }"
                  v-model="form.priceId"
                >
                  <option value="">金額を選択してください</option>
                  <option
                    v-for="(entry, index) in prices"
                    :key="index"
                    :value="entry.id"
                  >
                    {{ entry.price.toLocaleString() }}円
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <p v-if="form.errors.length > 0" class="form_error">
              <span v-for="(error, index) in form.errors" :key="index" class="valid_error">{{ error }}</span>
            </p>
            <p>
              <button
                type="submit"
                class="btn arrow"
                :disabled="isSend"
                @click.prevent="checkForm"
              >確認画面へ</button>
            </p>
          </div>
        </form>
      </ValidationObserver>
    </section>
    <section class="add_point text_center">
      <h3>追加ポイント表</h3>

      <table class="table white brown border text_left">
        <tr>
          <th>購入額</th>
          <th>追加ポイント数</th>
        </tr>
        <tr>
          <td>500円</td>
          <td>50pt</td>
        </tr>
        <tr>
          <td>1,500円</td>
          <td>150pt</td>
        </tr>
        <tr>
          <td>2,000円</td>
          <td>200pt</td>
        </tr>
        <tr>
          <td>3,000円</td>
          <td>300pt</td>
        </tr>
        <tr>
          <td>5,000円</td>
          <td class="caution--text">505pt</td>
        </tr>
        <tr>
          <td>10,000円</td>
          <td class="caution--text">1020pt</td>
        </tr>
        <tr>
          <td>20,000円</td>
          <td class="caution--text">2050pt</td>
        </tr>
        <tr>
          <td>30,000円</td>
          <td class="caution--text">3080pt</td>
        </tr>
        <tr>
          <td>50,000円</td>
          <td class="caution--text">5150pt</td>
        </tr>
        <tr>
          <td>70,000円</td>
          <td class="caution--text">7200pt</td>
        </tr>
        <tr>
          <td>100,000円</td>
          <td class="caution--text">10320pt</td>
        </tr>
      </table>
      <p class="text_left">
        ※上記は通常時の追加ポイントとなります。<br>
        キャンペーン等が適用されると更にお得です。
      </p>
    </section>
    <section class="no_mb no_padding text_center">
      <h3>お問い合わせ</h3>
      <div class="point_support">
        <p class="text_left">ご不明点などありましたら下記へお気軽にご連絡ください</p>
        <table class="support_info text_left">
          <tr>
            <th>お電話</th>
            <td>：<span class="telephone_num">{{ info.telephone }}</span></td>
          </tr>
          <tr>
            <th>メール</th>
            <td>：<a :href="`mailto:${settingData.inquiry_mail}?subject=${mailSubject}&amp;body=${mailBody}`" class="link_main--text text-decoration-underline">こちらから</a></td>
          </tr>
        </table>
        <div class="notice text_left">
          <p>お電話でのお問い合わせの際は下記の「会員ID」が必要になりますので、会員IDをお控えの上ご連絡ください。</p>
        </div>
        <table class="table white">
          <tr>
            <th>会員ID</th>
            <td>{{ user.user.id }}</td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { GET_ORDER } from '@/store/point/actions'

import {
  ValidationObserver,
  ValidationProvider,
  extend
} from 'vee-validate'
import {
  required
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: '{_field_}を選択してください'
})

export default {
  name: 'PointNetridecashTechcoinFormSet',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    user: Object,
    info: Object,
    product: Object,
    prices: Array
  },
  data () {
    return {
      paymentWay: 'netridecash_tc',
      form: {
        errors: [],
        priceId: ''
      },
      isSend: false,
      settingData: []
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    },
    mailSubject () {
      return `入金問い合わせ[${this.user.user.id}]`
    },
    mailBody () {
      return `会員ID：${this.user.user.id}`
    }
  },
  methods: {
    checkForm () {
      if (this.isSend) return
      this.isSend = true

      this.$refs.form.validate().then(success => {
        if (success) {
          this.getOrder()
        } else {
          this.isSend = false
        }
      })
    },
    getOrder () {
      this.$store.dispatch(GET_ORDER, {
        payment_way: this.paymentWay,
        price_id: this.form.priceId
      })
        .then((data) => {
          this.$router.pushIsses({
            name: 'PointNetridecashTechcoinConfirm',
            params: {
              order: data,
              product: this.product
            }
          })
        })
        .catch((error) => {
          this.isSend = false
          this.form.errors = []

          this.form.errors.push(error.message)
        })
    },
    getDefaultSetting () {
      this.$store.dispatch('getDefaultSetting')
        .then((data) => {
          this.settingData = data
        })
    }
  },
  created () {
    this.getDefaultSetting()
  }
}
</script>
